export default function buildRoutes(callback) {
  callback.isRouteMap = true;
  return callback;
}